// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_container__JavVK {
  position: relative;
}

.table_containerLoader__caSwI {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
}

.table_container__JavVK table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
}

.table_body__mZilT {
  overflow: auto;
}
.table_header__6WupV {
  color: white;
  font-weight: 600;
  font-size: 1em;
  display: table-header-group;
}

.table_head__aw90n {
  padding: 0.4em 0;
}
.table_row__zIzYI {
  /* border-bottom : 1px solid #636e72; */
  border-bottom: 1px solid #22835f;
  background: none;
  transition-duration: 150ms;
}
.table_rowPointer__Wvurf {
  /* border-bottom : 1px solid #636e72; */
  cursor: pointer;
  border-bottom: 1px solid #22835f;
  background: none;
  transition-duration: 150ms;
}
.table_row__zIzYI:hover * {
  transition-duration: 150ms;
  background: rgb(41, 141, 105);
  color: white;
}

.table_rowPointer__Wvurf:hover * {
  transition-duration: 150ms;
  background: rgb(41, 141, 105);
  color: white;
}

.table_data__H0nFJ {
  padding: 0.4em 0;
  width: 100vw;
}

.table_primary__I3v9V {
  background: #0984e3;
}
.table_secondary__gfCf9 {
  background: #636e72;
}
.table_success__Ot2oc {
  /* background : #00b894; */
  background: #22835f;
}
.table_warning__sc8EG {
  background: #fdcb6e;
}
.table_danger__-diFA {
  background: #d63031;
}

.table_actionButton__HIhck {
  background: none;
  border: none;
  cursor: pointer;
  color: #055437;
}

.table_disableActionButton__1eE9Y {
  background: none;
  border: none;
  color: black;
}

.table_voidTd__e4tjT {
  padding: 0.4em 0;
  width: 100vw;
  color: red;
  text-decoration: line-through;
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/table.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B","sourcesContent":[".container {\n  position: relative;\n}\n\n.containerLoader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.container table {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.body {\n  overflow: auto;\n}\n.header {\n  color: white;\n  font-weight: 600;\n  font-size: 1em;\n  display: table-header-group;\n}\n\n.head {\n  padding: 0.4em 0;\n}\n.row {\n  /* border-bottom : 1px solid #636e72; */\n  border-bottom: 1px solid #22835f;\n  background: none;\n  transition-duration: 150ms;\n}\n.rowPointer {\n  /* border-bottom : 1px solid #636e72; */\n  cursor: pointer;\n  border-bottom: 1px solid #22835f;\n  background: none;\n  transition-duration: 150ms;\n}\n.row:hover * {\n  transition-duration: 150ms;\n  background: rgb(41, 141, 105);\n  color: white;\n}\n\n.rowPointer:hover * {\n  transition-duration: 150ms;\n  background: rgb(41, 141, 105);\n  color: white;\n}\n\n.data {\n  padding: 0.4em 0;\n  width: 100vw;\n}\n\n.primary {\n  background: #0984e3;\n}\n.secondary {\n  background: #636e72;\n}\n.success {\n  /* background : #00b894; */\n  background: #22835f;\n}\n.warning {\n  background: #fdcb6e;\n}\n.danger {\n  background: #d63031;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #055437;\n}\n\n.disableActionButton {\n  background: none;\n  border: none;\n  color: black;\n}\n\n.voidTd {\n  padding: 0.4em 0;\n  width: 100vw;\n  color: red;\n  text-decoration: line-through;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `table_container__JavVK`,
	"containerLoader": `table_containerLoader__caSwI`,
	"body": `table_body__mZilT`,
	"header": `table_header__6WupV`,
	"head": `table_head__aw90n`,
	"row": `table_row__zIzYI`,
	"rowPointer": `table_rowPointer__Wvurf`,
	"data": `table_data__H0nFJ`,
	"primary": `table_primary__I3v9V`,
	"secondary": `table_secondary__gfCf9`,
	"success": `table_success__Ot2oc`,
	"warning": `table_warning__sc8EG`,
	"danger": `table_danger__-diFA`,
	"actionButton": `table_actionButton__HIhck`,
	"disableActionButton": `table_disableActionButton__1eE9Y`,
	"voidTd": `table_voidTd__e4tjT`
};
export default ___CSS_LOADER_EXPORT___;
